require("./liveAddressPlugin")(jQuery, window, document);



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/liveaddress/src/jquery.liveaddress.js
// module id = 188
// module chunks = 1 2 3 14 21 22